import { MeshRoll, ScreenDoor, LanaiRoof, CageFrameCorner, StormCage } from "@/components/ui/icons/A1Icons";

/**
 * TrustStrip — icon-led credibility row beneath the hero. Each pill is a
 * mini-card with a cyan icon ring, label, and accent. Dark navy band with
 * cyan hairlines top/bottom for section rhythm.
 *
 * Feb 2026 — switched from Lucide icons to the A1 screen-enclosure icon
 * kit so this row visually identifies the trade, not just the words.
 */
const PILLS = [
    { label: "Family-Owned Since 1999", Icon: MeshRoll },
    { label: "Free Estimates", Icon: ScreenDoor },
    { label: "Naples-Based", Icon: LanaiRoof },
    { label: "Clean Workmanship", Icon: CageFrameCorner },
    { label: "26+ Years SWFL Experience", Icon: StormCage },
];

export default function TrustStrip() {
    return (
        <div
            className="a1-trust-strip"
            data-testid="trust-strip"
        >
            <div className="a1-container py-6 md:py-8">
                <ul className="a1-trust-grid">
                    {PILLS.map(({ label, Icon }) => (
                        <li
                            key={label}
                            className="a1-trust-item"
                            data-testid={`trust-pill-${label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            <span className="a1-trust-icon" aria-hidden="true">
                                <Icon size={18} />
                            </span>
                            <span className="a1-trust-label">{label}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
